import WorkspaceLink from './WorkspaceLink';

export default WorkspaceLink;
